<template>
    <custom-drawer
        v-loading="m__loading"
        size="85%"
        :confirm_to_close="false"
        :visible.sync="visible_in_line"
    >
        <template slot="title">
            <div class="flex items-center justify-between flex-1 h-full pr-5">
                <div>
                    <p class="font-semibold text-sm">
                        {{ $t('page.campaign.create_rule') }}
                    </p>
                </div>
                <el-button
                    icon="el-icon-plus"
                    type="primary"
                    size="small"
                    @click="handleCreateAutomatedRule"
                >
                    {{ $t('button.create') }}
                </el-button>
            </div>
        </template>

        <div class="px-5 py-8">
            <div id="input_rule_name_wrapper" class="component-box">
                <p class="component-label">
                    {{ $t('page.campaign.rule_name') }}
                </p>

                <el-input
                    id="input_rule_name"
                    v-model="rule_name"
                    class="flex-1"
                    size="small"
                ></el-input>
            </div>

            <div class="flex mt-4 space-x-2">
                <div
                    v-for="(item, index) in list_template_automated_rules"
                    :key="index"
                    class="component-box !p-3 w-[240px] h-auto border-[1px]"
                    :class="[
                        selected_template_automated_rule === item.id
                            ? 'border-brand-atosa'
                            : 'border-transparent',
                        item.supports.some(
                            (item) => item === selected_apply_object.dimension
                        )
                            ? 'cursor-pointer hover:border-brand-atosa'
                            : 'cursor-not-allowed opacity-60'
                    ]"
                    @click="handleSelectTemplateAutomatedRule(item)"
                >
                    <p class="text-sm font-semibold">
                        {{ item.label }}
                    </p>

                    <p class="text-desc-text text-xs">
                        {{ item.description }}
                    </p>
                </div>
            </div>

            <div class="component-box flex flex-col mt-4 space-y-8">
                <div>
                    <div class="flex items-center mb-3">
                        <div
                            class="bg-brand-atosa--light util-flex-center p-2 rounded-md"
                        >
                            <i class="el-icon-box text-white"></i>
                        </div>

                        <p class="ml-2 text-sm font-semibold">
                            {{ $t('page.campaign.apply_rule') }}
                        </p>
                    </div>

                    <p class="text-sm font-semibold">
                        {{ $t('page.campaign.select_rule_for') }}
                    </p>

                    <!-- <el-select
                        v-model="selected_apply_object.pre_condition_type"
                        class="mt-1 w-[320px]"
                        size="small"
                        @change="handleChangePreConditionType()"
                    >
                        <el-option-group
                            v-for="group in pre_condition_type_options"
                            :key="group.label"
                            :label="group.label"
                        >
                            <el-option
                                v-for="item in group.options"
                                :key="item.value"
                                :label="item.label"
                                :value="item.value"
                            >
                            </el-option>
                        </el-option-group>
                    </el-select> -->

                    <el-radio-group
                        v-model="selected_apply_object.dimension"
                        class="flex flex-col space-y-3"
                    >
                        <el-radio :label="'CAMPAIGN'">
                            <span class="component-label">
                                {{ $t('common.campaign') }}
                            </span>
                            <div
                                v-if="
                                    selected_apply_object.dimension ===
                                    'CAMPAIGN'
                                "
                            >
                                <el-select
                                    v-model="list_campaigns"
                                    value-key="campaign_id"
                                    size="small"
                                    multiple
                                    :placeholder="
                                        $t('input.placeholder.please_select')
                                    "
                                    filterable
                                    class="mt-1 w-[350px]"
                                >
                                    <el-option
                                        v-for="item in m__data_for_pagination"
                                        :key="item.campaign_id"
                                        :label="item.campaign_name"
                                        :value="item"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </el-radio>
                        <el-radio :label="'ADGROUP'">
                            <span class="component-label">
                                {{ $t('common.adgroup') }}
                            </span>
                            <div
                                v-if="
                                    selected_apply_object.dimension ===
                                    'ADGROUP'
                                "
                            >
                                <el-select
                                    v-model="list_adgroups"
                                    value-key="adgroup_id"
                                    size="small"
                                    multiple
                                    :placeholder="
                                        $t('input.placeholder.please_select')
                                    "
                                    filterable
                                    class="mt-1 w-[350px]"
                                >
                                    <el-option
                                        v-for="item in m__data_adgroup_for_pagination"
                                        :key="item.adgroup_id"
                                        :label="item.adgroup_name"
                                        :value="item"
                                    >
                                    </el-option>
                                </el-select>
                            </div>
                        </el-radio>
                    </el-radio-group>
                </div>

                <div>
                    <div class="flex items-center mb-3">
                        <div
                            class="bg-brand-atosa--light util-flex-center p-2 rounded-md"
                        >
                            <i class="el-icon-star-on text-white"></i>
                        </div>

                        <p class="ml-2 text-sm font-semibold">
                            {{ $t('page.campaign.condition_and_action') }}
                        </p>
                    </div>

                    <ConditionAndAction
                        :selected_conditions.sync="selected_conditions"
                        :selected_actions.sync="selected_actions"
                        :dimension="selected_apply_object.dimension"
                        :currency="currency"
                    >
                    </ConditionAndAction>
                </div>

                <div>
                    <div class="flex items-center">
                        <div
                            class="bg-brand-atosa--light util-flex-center p-2 rounded-md"
                        >
                            <i class="el-icon-s-tools text-white"></i>
                        </div>

                        <p class="ml-2 text-sm font-semibold">
                            {{ $t('page.campaign.rule_settings') }}
                        </p>
                    </div>

                    <RunSchedule
                        :rule_exec_info.sync="rule_exec_info"
                    ></RunSchedule>

                    <div class="flex items-center mt-6 space-x-2">
                        <el-switch
                            v-model="switch_notify"
                            :disabled="
                                selected_actions.some(
                                    (item) => item.subject_type === 'MESSAGE'
                                )
                            "
                        >
                        </el-switch>
                        <p class="text-sm">
                            {{ $t('page.campaign.notify_me') }}
                        </p>
                    </div>
                    <p class="text-desc-text text-xs">
                        {{ $t('page.campaign.receive_notifications_by_email') }}
                    </p>

                    <NotifyMe
                        v-if="
                            notification.notification_type !==
                            'NOT_NOTIFICATION'
                        "
                        :notification.sync="notification"
                        class="mt-2"
                    ></NotifyMe>
                </div>
            </div>
        </div>
    </custom-drawer>
</template>

<script>
import NotifyMe from './notify-me'
import RunSchedule from './run-schedule'
import ConditionAndAction from './condition-and-action'
import moment from 'moment'
import { createAutomatedRule } from '@/services/atosa-tiktok-ads/auto-ads'
import { getCampaigns } from '@/services/atosa-tiktok-ads/campaign'
import { getAdGroups } from '@/services/atosa-tiktok-ads/adgroup'

const default_data = {
    switch_notify: true,
    selected_apply_object: {
        dimension: 'CAMPAIGN',
        dimension_ids: [],
        pre_condition_type: 'ALL_ACTIVE_CAMPAIGN'
    },
    rule_name: '',
    rule_exec_info: {
        exec_time_type: 'PER_HALF_HOUR',
        exec_time: '',
        time_period_info: []
    },
    notification: {
        notification_type: 'ANY_CHANGES',
        email_setting: {
            notification_period: 'EVERY_TIME',
            email_exec_time: [],
            no_result_notification: false,
            mute_option: 'UNMUTE'
        }
    },
    selected_actions: [
        {
            subject_type: 'TURN_OFF',
            action_type: 'ADJUST_TO',
            value_type: 'EXACT',
            time_end: '',
            value: {
                use_limit: false,
                value: 0,
                limit: 0
            },
            frequency_info: {
                type: 'ONLY_ONCE',
                custom_frequency_type: 'N_MINTUE_Y_TIMES',
                time: 0,
                count: 0
            }
        }
    ],
    selected_conditions: [
        {
            subject_type: 'spend',
            range_type: 'TODAY',
            calculation_type: 'OF_EACH_OBJECT',
            match_type: 'GT',
            values: [1]
        }
    ],
    selected_template_automated_rule: 1
}

export default {
    components: {
        NotifyMe,
        RunSchedule,
        ConditionAndAction
    },

    props: [
        'visible',
        'tiktok_account_id',
        'advertiser_id',
        'autobot_id',
        'currency',
        'type',
        'multiple_selection',
        'selected_ads_account_list'
    ],

    data() {
        return {
            ...default_data,
            list_template_automated_rules: [
                {
                    id: 1,
                    label: this.$t(
                        'page.campaign.automated_rule_create_custom_rule'
                    ),
                    description: this.$t(
                        'page.campaign.automated_rule_description_create_custom_rule'
                    ),
                    supports: ['AD', 'ADGROUP', 'CAMPAIGN']
                },
                {
                    id: 2,
                    label: this.$t(
                        'page.campaign.automated_rule_schedule_delivery'
                    ),
                    description: this.$t(
                        'page.campaign.automated_rule_description_schedule_delivery'
                    ),
                    supports: ['AD', 'ADGROUP', 'CAMPAIGN']
                },
                {
                    id: 3,
                    label: this.$t(
                        'page.campaign.automated_rule_control_budget'
                    ),
                    description: this.$t(
                        'page.campaign.automated_rule_description_control_budget'
                    ),
                    supports: ['AD', 'ADGROUP', 'CAMPAIGN']
                }
            ],
            default_pre_condition_type_options: [
                {
                    label: this.$t('common.active'),
                    options: [
                        {
                            value: 'ALL_ACTIVE_CAMPAIGN',
                            value_dimension: 'CAMPAIGN',
                            label: this.$t('common.all_active_campaign')
                        },
                        {
                            value: 'ALL_ACTIVE_AD_GROUP',
                            value_dimension: 'ADGROUP',
                            label: this.$t('common.all_active_adgroup')
                        },
                        {
                            value: 'ALL_ACTIVE_AD',
                            value_dimension: 'AD',
                            label: this.$t('common.all_active_ad')
                        }
                    ]
                },
                {
                    label: this.$t('common.inactive'),
                    options: [
                        {
                            value: 'ALL_INACTIVE_CAMPAIGN',
                            value_dimension: 'CAMPAIGN',
                            label: this.$t('common.all_inactive_campaign')
                        },
                        {
                            value: 'ALL_INACTIVE_AD_GROUP',
                            value_dimension: 'ADGROUP',
                            label: this.$t('common.all_inactive_adgroup')
                        },
                        {
                            value: 'ALL_INACTIVE_AD',
                            value_dimension: 'AD',
                            label: this.$t('common.all_inactive_ad')
                        }
                    ]
                }
            ],
            pre_condition_type_options: [],
            m__data_for_pagination: [],
            list_campaigns: [],
            list_adgroups: [],
            m__page_info: {},
            m__data_adgroup_for_pagination: [],
            m__loading: false
        }
    },

    computed: {
        visible_in_line: {
            get: function () {
                return this.visible
            },
            set: function (val) {
                this.$emit('update:visible', val)
            }
        },
        target_dimension() {
            return [
                this.selected_apply_object.dimension,
                this.list_adgroups,
                this.list_campaigns
            ]
        }
    },

    watch: {
        visible_in_line() {
            if (this.visible_in_line) {
                for (const [key, value] of Object.entries(default_data)) {
                    this[key] = JSON.parse(JSON.stringify(value))
                }

                const now = moment()
                const date = now.format('YYYYMMDDHHmmss')
                this.rule_name = `${this.$t('common.rule')}_${date}`

                if (this.list_campaigns.length) {
                    let options = []
                    let dimension_ids = []
                    const xxx = this.multiple_selection.length

                    if (this.selected_apply_object.dimension === 'CAMPAIGN') {
                        options = [
                            {
                                value: 'SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.xxx_campaign_has_selected',
                                    {
                                        xxx
                                    }
                                )
                            },
                            {
                                value: 'ALL_ACTIVE_AD_GROUP_UNDER_SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.all_active_adgroup_under_xxx_campaign_has_selected',
                                    {
                                        xxx
                                    }
                                )
                            },
                            {
                                value: 'ALL_ACTIVE_AD_UNDER_SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.all_active_ad_under_xxx_campaign_has_selected',
                                    {
                                        xxx
                                    }
                                )
                            },
                            {
                                value: 'ALL_INACTIVE_AD_GROUP_UNDER_SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.all_inactive_adgroup_under_xxx_campaign_has_selected',
                                    {
                                        xxx
                                    }
                                )
                            },
                            {
                                value: 'ALL_INACTIVE_AD_UNDER_SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.all_inactive_ad_under_xxx_campaign_has_selected',
                                    {
                                        xxx
                                    }
                                )
                            }
                        ]

                        dimension_ids = this.multiple_selection.map(
                            (item) => item.campaign.campaign_id
                        )
                    } else if (
                        this.selected_apply_object.dimension === 'ADGROUP'
                    ) {
                        options = [
                            {
                                value: 'SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.xxx_adgroup_has_selected',
                                    {
                                        xxx
                                    }
                                )
                            },
                            {
                                value: 'ALL_ACTIVE_AD_UNDER_SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.all_active_ad_under_xxx_adgroup_has_selected',
                                    {
                                        xxx
                                    }
                                )
                            },
                            {
                                value: 'ALL_INACTIVE_AD_UNDER_SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.all_inactive_ad_under_xxx_adgroup_has_selected',
                                    {
                                        xxx
                                    }
                                )
                            }
                        ]

                        dimension_ids = this.multiple_selection.map(
                            (item) => item.adgroup.adgroup_id
                        )
                    } else if (this.selected_apply_object.dimension === 'AD') {
                        options = [
                            {
                                value: 'SELECTED',
                                value_dimension: this.type,
                                label: this.$t(
                                    'page.campaign.xxx_ad_has_selected',
                                    {
                                        xxx: this.multiple_selection.length
                                    }
                                )
                            }
                        ]

                        dimension_ids = this.multiple_selection.map(
                            (item) => item.ad.ad_id
                        )
                    }

                    const temp = [
                        {
                            label: this.$t('common.selected'),
                            options
                        }
                    ]
                    this.pre_condition_type_options = [
                        ...temp,
                        ...this.default_pre_condition_type_options
                    ]

                    this.selected_apply_object.pre_condition_type = 'SELECTED'
                    this.selected_apply_object.dimension_ids = dimension_ids
                    this.selected_apply_object.dimension = this.type
                } else {
                    this.pre_condition_type_options = [
                        ...this.default_pre_condition_type_options
                    ]

                    this.selected_apply_object.pre_condition_type =
                        'ALL_ACTIVE_CAMPAIGN'
                    this.selected_apply_object.dimension_ids = []
                    this.selected_apply_object.dimension = 'CAMPAIGN'
                }
            }
        },

        target_dimension() {
            if (this.selected_apply_object.dimension === 'CAMPAIGN') {
                this.multiple_selection = this.list_campaigns
            } else if (this.selected_apply_object.dimension === 'ADGROUP') {
                this.multiple_selection = this.list_adgroups
            }

            let options = []
            let dimension_ids = []
            const xxx = this.multiple_selection.length

            if (this.selected_apply_object.dimension === 'CAMPAIGN') {
                options = [
                    {
                        value: 'SELECTED',
                        value_dimension: this.type,
                        label: this.$t(
                            'page.campaign.xxx_campaign_has_selected',
                            {
                                xxx
                            }
                        )
                    },
                    {
                        value: 'ALL_ACTIVE_AD_GROUP_UNDER_SELECTED',
                        value_dimension: this.type,
                        label: this.$t(
                            'page.campaign.all_active_adgroup_under_xxx_campaign_has_selected',
                            {
                                xxx
                            }
                        )
                    },
                    {
                        value: 'ALL_ACTIVE_AD_UNDER_SELECTED',
                        value_dimension: this.type,
                        label: this.$t(
                            'page.campaign.all_active_ad_under_xxx_campaign_has_selected',
                            {
                                xxx
                            }
                        )
                    },
                    {
                        value: 'ALL_INACTIVE_AD_GROUP_UNDER_SELECTED',
                        value_dimension: this.type,
                        label: this.$t(
                            'page.campaign.all_inactive_adgroup_under_xxx_campaign_has_selected',
                            {
                                xxx
                            }
                        )
                    },
                    {
                        value: 'ALL_INACTIVE_AD_UNDER_SELECTED',
                        value_dimension: this.type,
                        label: this.$t(
                            'page.campaign.all_inactive_ad_under_xxx_campaign_has_selected',
                            {
                                xxx
                            }
                        )
                    }
                ]

                console.log(
                    this.multiple_selection,
                    'this.multiple_selection dsaflsadkfjlskdaf'
                )

                dimension_ids = this.multiple_selection.map(
                    (item) => item.campaign_id
                )

                console.log(dimension_ids, 'dimension_ids dsaflsadkfjlskdaf')
            } else if (this.selected_apply_object.dimension === 'ADGROUP') {
                options = [
                    {
                        value: 'SELECTED',
                        value_dimension: this.type,
                        label: this.$t(
                            'page.campaign.xxx_adgroup_has_selected',
                            {
                                xxx
                            }
                        )
                    },
                    {
                        value: 'ALL_ACTIVE_AD_UNDER_SELECTED',
                        value_dimension: this.type,
                        label: this.$t(
                            'page.campaign.all_active_ad_under_xxx_adgroup_has_selected',
                            {
                                xxx
                            }
                        )
                    },
                    {
                        value: 'ALL_INACTIVE_AD_UNDER_SELECTED',
                        value_dimension: this.type,
                        label: this.$t(
                            'page.campaign.all_inactive_ad_under_xxx_adgroup_has_selected',
                            {
                                xxx
                            }
                        )
                    }
                ]

                dimension_ids = this.multiple_selection.map(
                    (item) => item.adgroup_id
                )
            }
            const temp = [
                {
                    label: this.$t('common.selected'),
                    options
                }
            ]

            this.pre_condition_type_options = [
                ...temp,
                ...this.default_pre_condition_type_options
            ]

            this.selected_apply_object.pre_condition_type = 'SELECTED'
            this.selected_apply_object.dimension_ids = dimension_ids
        },

        // 'selected_apply_object.dimension'() {
        //     for (const [key, value] of Object.entries(default_data)) {
        //         this[key] = JSON.parse(JSON.stringify(value))
        //     }

        //     const now = moment()
        //     const date = now.format('YYYYMMDDHHmmss')
        //     this.rule_name = `${this.$t('common.rule')}_${date}`

        //     this.multiple_selection = this.list_campaigns
        //     this.type = this.selected_apply_object.dimension
        //     console.log(
        //         this.multiple_selection,
        //         this.type,
        //         'length là dsafldsak'
        //     )

        //     if (this.multiple_selection.length) {
        //         let options = []
        //         let dimension_ids = []
        //         const xxx = this.multiple_selection.length

        //         if (this.selected_apply_object.dimension === 'CAMPAIGN') {
        //             options = [
        //                 {
        //                     value: 'SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.xxx_campaign_has_selected',
        //                         {
        //                             xxx
        //                         }
        //                     )
        //                 },
        //                 {
        //                     value: 'ALL_ACTIVE_AD_GROUP_UNDER_SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.all_active_adgroup_under_xxx_campaign_has_selected',
        //                         {
        //                             xxx
        //                         }
        //                     )
        //                 },
        //                 {
        //                     value: 'ALL_ACTIVE_AD_UNDER_SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.all_active_ad_under_xxx_campaign_has_selected',
        //                         {
        //                             xxx
        //                         }
        //                     )
        //                 },
        //                 {
        //                     value: 'ALL_INACTIVE_AD_GROUP_UNDER_SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.all_inactive_adgroup_under_xxx_campaign_has_selected',
        //                         {
        //                             xxx
        //                         }
        //                     )
        //                 },
        //                 {
        //                     value: 'ALL_INACTIVE_AD_UNDER_SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.all_inactive_ad_under_xxx_campaign_has_selected',
        //                         {
        //                             xxx
        //                         }
        //                     )
        //                 }
        //             ]

        //             dimension_ids = this.multiple_selection.map(
        //                 (item) => item.campaign.campaign_id
        //             )
        //         } else if (this.selected_apply_object.dimension === 'ADGROUP') {
        //             options = [
        //                 {
        //                     value: 'SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.xxx_adgroup_has_selected',
        //                         {
        //                             xxx
        //                         }
        //                     )
        //                 },
        //                 {
        //                     value: 'ALL_ACTIVE_AD_UNDER_SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.all_active_ad_under_xxx_adgroup_has_selected',
        //                         {
        //                             xxx
        //                         }
        //                     )
        //                 },
        //                 {
        //                     value: 'ALL_INACTIVE_AD_UNDER_SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.all_inactive_ad_under_xxx_adgroup_has_selected',
        //                         {
        //                             xxx
        //                         }
        //                     )
        //                 }
        //             ]

        //             dimension_ids = this.multiple_selection.map(
        //                 (item) => item.adgroup.adgroup_id
        //             )
        //         } else if (this.selected_apply_object.dimension === 'AD') {
        //             options = [
        //                 {
        //                     value: 'SELECTED',
        //                     value_dimension: this.type,
        //                     label: this.$t(
        //                         'page.campaign.xxx_ad_has_selected',
        //                         {
        //                             xxx: this.multiple_selection.length
        //                         }
        //                     )
        //                 }
        //             ]

        //             dimension_ids = this.multiple_selection.map(
        //                 (item) => item.ad.ad_id
        //             )
        //         }

        //         const temp = [
        //             {
        //                 label: this.$t('common.selected'),
        //                 options
        //             }
        //         ]
        //         this.pre_condition_type_options = [
        //             ...temp,
        //             ...this.default_pre_condition_type_options
        //         ]

        //         this.selected_apply_object.pre_condition_type = 'SELECTED'
        //         this.selected_apply_object.dimension_ids = dimension_ids
        //         this.selected_apply_object.dimension = this.type
        //     } else {
        //         this.pre_condition_type_options = [
        //             ...this.default_pre_condition_type_options
        //         ]

        //         this.selected_apply_object.pre_condition_type =
        //             'ALL_ACTIVE_CAMPAIGN'
        //         this.selected_apply_object.dimension_ids = []
        //         this.selected_apply_object.dimension = 'CAMPAIGN'
        //     }
        // },

        switch_notify() {
            if (this.switch_notify) {
                if (
                    this.selected_actions.some(
                        (item) => item.subject_type === 'MESSAGE'
                    )
                ) {
                    this.notification.notification_type = 'TASK_FINISH'
                } else {
                    this.notification.notification_type = 'ANY_CHANGES'
                }
            } else {
                this.notification.notification_type = 'NOT_NOTIFICATION'
            }
        },

        selected_actions() {
            if (
                this.selected_actions.some(
                    (item) => item.subject_type === 'MESSAGE'
                )
            ) {
                this.switch_notify = true
                this.notification.notification_type = 'TASK_FINISH'
            } else {
                this.notification.notification_type = 'ANY_CHANGES'
            }
        },

        'selected_apply_object.pre_condition_type'() {
            this.selected_template_automated_rule =
                this.list_template_automated_rules[0].id

            this.selected_conditions = JSON.parse(
                JSON.stringify(default_data.selected_conditions)
            )

            this.selected_actions = JSON.parse(
                JSON.stringify(default_data.selected_actions)
            )
        },

        list_campaigns() {}
    },

    mounted() {
        this.pre_condition_type_options = [
            ...this.default_pre_condition_type_options
        ]

        this.fetchCampaigns()

        this.fetchAdgroups()
    },

    methods: {
        checkOverlap(arr) {
            for (let i = 0; i < arr.length; i++) {
                const subArr1 = arr[i]
                const [start1, end1] = subArr1

                for (let j = i + 1; j < arr.length; j++) {
                    const subArr2 = arr[j]
                    const [start2, end2] = subArr2

                    if (
                        (start1 <= start2 && start2 <= end1) ||
                        (start2 <= start1 && start1 <= end2)
                    ) {
                        return true // Giao nhau
                    }
                }
            }
            return false // Không giao nhau
        },
        async handleCreateAutomatedRule() {
            if (!this.rule_name) {
                this.p__showNotify(
                    'warning',
                    this.$t('page.campaign.please_select_input_rule_name')
                )

                document
                    .getElementById('input_rule_name_wrapper')
                    .scrollIntoView({ behavior: 'smooth' })
                document.getElementById('input_rule_name').focus()
                document.getElementById('input_rule_name').className +=
                    ' border-red border-[1px] rounded-[8px]'

                return
            }

            if (
                this.rule_exec_info.exec_time_type ===
                'HALF_HOUR_IN_SPECIFIC_TIME_PERIOD'
            ) {
                let has_error = false
                const specified_times = []

                this.rule_exec_info.time_period_info.forEach((info) => {
                    if (info.start_time && info.end_time) {
                        let arr = info.start_time.split(':')
                        const start_time_value = +arr[0] * 60 + +arr[1]

                        arr = info.end_time.split(':')
                        const end_time_value = +arr[0] * 60 + +arr[1]
                        if (start_time_value > end_time_value) {
                            has_error = true
                            this.p__showNotify(
                                'warning',
                                this.$t(
                                    'page.campaign.message_start_time_less_than_or_equal_end_time_in_specified_time_period_automated_rule'
                                )
                            )

                            return
                        }

                        if (!info.num.length) {
                            has_error = true
                            this.p__showNotify(
                                'warning',
                                this.$t(
                                    'page.campaign.message_havent_select_day_in_specified_time_period_automated_rule'
                                )
                            )

                            return
                        }

                        info.num.forEach((day) => {
                            const second = +day * 24 * 60
                            specified_times.push([
                                second + start_time_value,
                                second + end_time_value
                            ])
                        })
                    } else {
                        has_error = true
                        return
                    }
                })

                if (this.checkOverlap(specified_times)) {
                    has_error = true
                    this.p__showNotify(
                        'warning',
                        this.$t(
                            'page.campaign.message_overlap_specified_time_period_automated_rule'
                        )
                    )
                }

                if (has_error) {
                    return
                }
            }

            this.m__loading = true

            try {
                const conditions = this.selected_conditions.map((item) => {
                    if (!item.calculation_type) {
                        delete item.calculation_type
                    }

                    return {
                        ...item,
                        values: item.values.map((i) => `${i}`)
                    }
                })

                await createAutomatedRule(this.tiktok_account_id, {
                    autobot_id: this.autobot_id,
                    rules: [
                        {
                            name: this.rule_name,
                            notification: this.notification,
                            rule_exec_info: this.rule_exec_info,
                            apply_objects: [this.selected_apply_object],
                            actions: [...this.selected_actions],
                            conditions
                        }
                    ]
                })

                this.p__showNotify(
                    'success',
                    this.$t('common.create_data_success')
                )

                this.visible_in_line = false
            } catch (error) {
                console.error(error)
            }

            this.m__loading = false
        },

        handleChangePreConditionType() {
            for (const iterator of this.pre_condition_type_options) {
                for (const item of iterator.options) {
                    if (
                        item.value ===
                        this.selected_apply_object.pre_condition_type
                    ) {
                        this.selected_apply_object.dimension =
                            item.value_dimension
                        return
                    }
                }
            }
        },

        handleSelectTemplateAutomatedRule(item) {
            if (
                item.supports.every(
                    (item) => item !== this.selected_apply_object.dimension
                )
            ) {
                return
            }

            this.selected_template_automated_rule = item.id

            if (item.id === 1) {
                this.selected_conditions = [
                    {
                        subject_type: 'spend',
                        range_type: 'TODAY',
                        calculation_type: 'OF_EACH_OBJECT',
                        match_type: 'GT',
                        values: [1]
                    }
                ]

                this.selected_actions = [
                    {
                        subject_type: 'MESSAGE',
                        action_type: 'ADJUST_TO',
                        value_type: 'EXACT',
                        time_end: '',
                        value: {
                            use_limit: false,
                            value: 0,
                            limit: 0
                        },
                        frequency_info: {
                            type: 'ONLY_ONCE',
                            custom_frequency_type: 'N_MINTUE_Y_TIMES',
                            time: 0,
                            count: 0
                        }
                    }
                ]

                return
            }

            if (item.id === 2) {
                const inactive = [
                    'ALL_INACTIVE_CAMPAIGN',
                    'ALL_INACTIVE_AD_GROUP',
                    'ALL_INACTIVE_AD'
                ].some(
                    (item) =>
                        item === this.selected_apply_object.pre_condition_type
                )

                const match_type_cpa = inactive ? 'LT' : 'GT'

                this.selected_conditions = [
                    {
                        subject_type: 'cost_per_conversion',
                        range_type: 'PAST_THREE_DAYS',
                        calculation_type: '',
                        match_type: match_type_cpa,
                        values: [1]
                    }
                ]

                const subject_type_action = inactive ? 'TURN_ON' : 'TURN_OFF'

                this.selected_actions = [
                    {
                        subject_type: subject_type_action,
                        action_type: 'ADJUST_TO',
                        value_type: 'EXACT',
                        time_end: '',
                        value: {
                            use_limit: false,
                            value: 0,
                            limit: 0
                        },
                        frequency_info: {
                            type: 'ONLY_ONCE',
                            custom_frequency_type: 'N_MINTUE_Y_TIMES',
                            time: 0,
                            count: 0
                        }
                    }
                ]

                return
            }

            if (item.id === 3) {
                const inactive = [
                    'ALL_INACTIVE_CAMPAIGN',
                    'ALL_INACTIVE_AD_GROUP',
                    'ALL_INACTIVE_AD'
                ].some(
                    (item) =>
                        item === this.selected_apply_object.pre_condition_type
                )

                const match_type_cpa = inactive ? 'LT' : 'GT'

                this.selected_conditions = [
                    {
                        subject_type: 'spend',
                        range_type: 'PAST_THREE_DAYS',
                        calculation_type: 'ALL_OBJECTS',
                        match_type: 'GT',
                        values: [1]
                    },
                    {
                        subject_type: 'cost_per_conversion',
                        range_type: 'PAST_THREE_DAYS',
                        calculation_type: '',
                        match_type: match_type_cpa,
                        values: [1]
                    }
                ]

                const subject_type_action = inactive ? 'TURN_ON' : 'TURN_OFF'

                this.selected_actions = [
                    {
                        subject_type: subject_type_action,
                        action_type: 'ADJUST_TO',
                        value_type: 'EXACT',
                        time_end: '',
                        value: {
                            use_limit: false,
                            value: 0,
                            limit: 0
                        },
                        frequency_info: {
                            type: 'ONLY_ONCE',
                            custom_frequency_type: 'N_MINTUE_Y_TIMES',
                            time: 0,
                            count: 0
                        }
                    }
                ]

                return
            }
        },

        async fetchCampaigns() {
            this.m__loading = true

            const response = await getCampaigns(this.tiktok_account_id, {
                advertiser_id: this.selected_ads_account_list[0],
                page: 1,
                page_size: 100
            })

            // this.m__data_for_pagination = [
            //     ...this.m__data_for_pagination,
            //     ...response.data.list
            // ].filter((item) => item.campaign_id !== first_campaign.campaign_id)

            this.m__data_for_pagination = [...response.data.list]

            const first_campaign = this.m__data_for_pagination[0]
            this.list_campaigns.push(first_campaign)

            // this.m__data_for_pagination = [
            //     first_campaign,
            //     ...this.m__data_for_pagination
            // ]

            this.m__page_info = response.data.page_info

            this.m__loading = false
        },

        async fetchAdgroups() {
            this.m__loading = true

            const response = await getAdGroups(this.tiktok_account_id, {
                advertiser_id: this.selected_ads_account_list[0],
                page: 1,
                page_size: 100
            })

            this.m__data_adgroup_for_pagination = [...response.data.list]

            const first_adgroup = this.m__data_adgroup_for_pagination[0]
            this.list_adgroups.push(first_adgroup)

            console.log(
                this.m__data_adgroup_for_pagination,
                'sạdlfdsakfjlsadkfdhj'
            )

            this.m__loading = false
        }
    }
}
</script>
